'use client'
/**
 * The browser build's `posthog-js/react` (FRIDGE-1648). The real module imports posthog-js
 * itself, so keeping it would put the library back in the first download. The site uses two
 * names from it: PostHogProvider (app/providers.tsx passes the client and renders children)
 * and usePostHog (every capture site), and both work on the one deferred client.
 */
import type { ReactNode } from 'react'
import posthog from './posthog-browser'

export function PostHogProvider({ children }: { children?: ReactNode; client?: unknown; apiKey?: string; options?: unknown }) {
  return <>{children}</>
}

export function usePostHog() {
  return posthog
}
